var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTsBrandmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 795.6 684.94125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#12649f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M610.70101,128.04063l-238.23769,.76733-83.48996,360.03474h-120.27747L252.20094,128.80796H11.66126L38.47312,10.08038H637.49781l-26.7968,117.96025Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.46709,554.33738l82.73772-359.26741h359.25238l-27.56427,119.49505h-239.77236l-82.72268,359.26727H76.13047l27.57933-119.49491h239.75729Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsBrandmark);
export default __webpack_public_path__ + "static/media/ts-brandmark.395fa0b9a873b7f10436765aa74dd287.svg";
export { ForwardRef as ReactComponent };